import React from 'react';
import styles from './TreeItem.module.scss';
import classNames from 'classnames';
import {
  ChangeableCheckbox,
  ChevronDownIcon,
} from '../../../resource/icons';

const TreeItem = ({
  onOpen,
  opened,
  expandable,
  onSelect,
  object,
  allData,
}) => {
  return (
    <>
      <div
        className={styles.branch}
        key={`branch-${object.label}`}
        onClick={onOpen}
      >
        {object.canBeChecked && (
          <label
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={styles.checkboxLabel}
          >
            <input
              type="checkbox"
              className={styles.trueCheckbox}
              checked={object.checked}
              onChange={({ target: { checked } }) => {
                onSelect(object, checked, allData);
              }}
            />
            <ChangeableCheckbox
              indeterminateCheckBox={
                object.indeterminate && !object.checked
                  ? 'indeterminate'
                  : undefined
              }
              checked={object.checked}
              className={styles.checkbox}
            />
          </label>
        )}
        <span>{object.label}</span>
        <div className={styles.spacer} />
        {expandable && (
          <ChevronDownIcon
            className={classNames({ [styles.chevronOpened]: opened })}
          />
        )}
      </div>
    </>
  );
};

export default TreeItem;
